(function () {
  if (window.__heroicaCardSubscriptionBound) return;
  window.__heroicaCardSubscriptionBound = true;

  var style = document.createElement('style');
  style.id = 'heroica-card-subscription-style';
  style.textContent = [
    '.heroica-card-purchase-selector>[data-btn-addtocart]{display:none!important}',
    '.heroica-card-purchase{display:grid;gap:5px;width:100%;font-family:Heroica,var(--font-body-family),sans-serif;color:#602221;text-align:left}',
    '.heroica-card-purchase__option{box-sizing:border-box;display:flex;align-items:flex-start;gap:8px;width:100%;min-height:50px;padding:9px 10px;border:1px solid rgba(96,34,33,.22);border-radius:10px;background:#fff;cursor:pointer;transition:border-color .2s,background-color .2s,box-shadow .2s}',
    '.heroica-card-purchase__option.is-selected{border-color:#e64891;background:#fff4f8;box-shadow:0 0 0 1px rgba(230,72,145,.08)}',
    '.heroica-card-purchase__option input{display:block!important;visibility:visible!important;opacity:1!important;position:static!important;clip:auto!important;pointer-events:auto!important;appearance:none!important;-webkit-appearance:none!important;flex:0 0 14px;width:14px;height:14px;margin:1px 0 0;border:1.5px solid #9f7473;border-radius:50%;background:#fff;box-shadow:inset 0 0 0 3px #fff}',
    '.heroica-card-purchase__option input:checked{border-color:#e64891;background:#e64891}',
    '.heroica-card-purchase__option--single{min-height:38px;padding:7px 10px;align-items:center}',
    '.heroica-card-purchase__option--single input{margin-top:0}',
    '.heroica-card-purchase__copy{display:block;min-width:0;flex:1}',
    '.heroica-card-purchase__line{display:flex;align-items:flex-start;justify-content:space-between;gap:6px;font-size:13px;line-height:1.15}',
    '.heroica-card-purchase__line strong{font-weight:800}',
    '.heroica-card-purchase__line strong em{display:inline-block;margin-left:3px;padding:2px 4px;border-radius:4px;background:#f6acd0;color:#602221;font-size:9px;font-style:normal;line-height:1}',
    '.heroica-card-purchase__line b{flex:0 0 auto;font-size:13px;font-weight:800;white-space:nowrap}',
    '.heroica-card-purchase__copy small{display:block;margin-top:4px;color:#76504f;font-size:10.5px;line-height:1.25}',
    '.heroica-card-purchase__submit{box-sizing:border-box;width:100%;min-height:46px;padding:10px 14px;border:1px solid #e64891;border-radius:30px;background:#e64891;color:#fbe7cc;font-family:Heroica,var(--font-body-family),sans-serif;font-size:14px;font-weight:800;line-height:1.1;text-transform:uppercase;letter-spacing:.01em;cursor:pointer;transition:opacity .2s,transform .2s}',
    '.heroica-card-purchase__submit:hover{transform:translateY(-1px)}',
    '.heroica-card-purchase__submit.is-loading,.heroica-card-purchase__submit:disabled{cursor:wait;opacity:.65;transform:none}',
    '@media(max-width:767px){.heroica-card-purchase{gap:4px}.heroica-card-purchase__option{min-height:44px;padding:7px;gap:6px;border-radius:8px}.heroica-card-purchase__option--single{min-height:34px;padding:5px 7px}.heroica-card-purchase__option input{flex-basis:12px;width:12px;height:12px;box-shadow:inset 0 0 0 2.5px #fff}.heroica-card-purchase__line{display:grid;grid-template-columns:minmax(0,1fr);gap:3px;font-size:11px}.heroica-card-purchase__option--single .heroica-card-purchase__line{display:flex;align-items:center;justify-content:space-between;gap:4px}.heroica-card-purchase__line b{font-size:12px}.heroica-card-purchase__copy small{margin-top:3px;font-size:9px;line-height:1.2}.heroica-card-purchase__submit{min-height:42px;padding:9px 8px;font-size:11px}}'
  ].join('');
  document.head.appendChild(style);

  function setCartCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = cart.item_count;
    });
  }

  function showError(message) {
    if (window.halo && typeof window.halo.showWarning === 'function') {
      window.halo.showWarning(message);
      return;
    }
    console.error('[Heroica assinatura]', message);
  }

  function updateSelector(selector) {
    var selected = selector.querySelector('input[type="radio"]:checked');
    selector.querySelectorAll('.heroica-card-purchase__option').forEach(function (option) {
      option.classList.toggle('is-selected', !!option.querySelector('input:checked'));
    });
    var submit = selector.querySelector('[data-heroica-card-purchase-submit]');
    if (submit && !submit.disabled) {
      submit.textContent = selected && selected.value === 'single' ? 'Adicionar compra única' : 'Assinar e adicionar';
    }
  }

  document.addEventListener('change', function (event) {
    var selector = event.target.closest('[data-heroica-card-purchase]');
    if (selector && event.target.matches('input[type="radio"]')) updateSelector(selector);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-heroica-card-purchase-submit]');
    if (!button || button.disabled) return;

    event.preventDefault();
    event.stopPropagation();

    var selector = button.closest('[data-heroica-card-purchase]');
    var selected = selector.querySelector('input[type="radio"]:checked');
    var purchaseType = selected ? selected.value : 'subscription';
    var originalText = button.textContent.trim();
    var variantId = Number(selector.getAttribute('data-variant-id'));
    var sellingPlanId = Number(selector.getAttribute('data-selling-plan-id'));
    if (!variantId || (purchaseType === 'subscription' && !sellingPlanId)) return;

    button.disabled = true;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Adicionando...';

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (purchaseType === 'subscription') formData.append('selling_plan', sellingPlanId);

    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: formData
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Não foi possível adicionar o produto.');
          return data;
        });
      })
      .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        setCartCount(cart);
        button.textContent = purchaseType === 'subscription' ? 'Assinatura adicionada' : 'Produto adicionado';
        if (typeof window.updateCart === 'function') window.updateCart();
        else document.body.classList.add('cart-sidebar-show');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'heroica_collection_purchase_added',
          purchase_type: purchaseType,
          product_name: selector.getAttribute('data-product-title') || '',
          variant_id: variantId,
          selling_plan_id: purchaseType === 'subscription' ? sellingPlanId : null
        });
      })
      .catch(function (error) {
        showError(error.message || 'Não foi possível adicionar o produto.');
        button.textContent = 'Tentar novamente';
      })
      .finally(function () {
        window.setTimeout(function () {
          button.disabled = false;
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
          button.textContent = originalText;
          updateSelector(selector);
        }, 1600);
      });
  });
})();
